import { Form } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Axios from "@/shared/api/axios";
import StatusModal from "@/components/ui/StatusModal";
import LoadingButton from "@/components/ui/LoadingButton";
import { useSelector, useDispatch } from "react-redux";
import { setUserToken, setUserId } from "@/shared/store/slices/userSlice";
import { setIdolList } from "@/shared/store/slices/idolSlice";

// 會員登入表單
function LoginForm({ onShowIdol, onShowNickname }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const idolList = useSelector((state) => state.idol.list);

  // Unified status modal
  const statusModalRef = useRef(null);
  const [currentStatusCode, setCurrentStatusCode] = useState('');

  const [validated, setValidated] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [init, setInit] = useState(true);

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (event) => {
    const formCheck = event.currentTarget;

    event.preventDefault();

    if (formCheck.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setIsSubmitting(true);
    try {
      const formData = await Axios.post("/user/login", form);
      const statusCode = formData.data.status_code;

      if (statusCode === "SYSTEM_1000") {
        const token = formData.data.access_token;
        dispatch(setUserToken(token));
        dispatch(setUserId(formData.data.user_id));
      } else {
        // Show error modal for any non-success status
        setCurrentStatusCode(statusCode);
        statusModalRef.current?.show();
      }
    } catch (error) {
      // NETWORK_ERROR 由全域 ServerErrorPage 處理，不另外顯示 modal
      if (error.httpErrorCode && error.httpErrorCode !== 'NETWORK_ERROR') {
        setCurrentStatusCode(error.httpErrorCode);
        statusModalRef.current?.show();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (idolList.length > 0) {
      dispatch(setIdolList([]));
    }
    setInit(false);
  }, []);

  useEffect(() => {
    if (!init) {
      idolList.length > 0 ? onShowIdol(true) : onShowNickname(true);
    }
  }, [idolList]);

  return (
    <>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Control
            onChange={handleChange}
            type="email"
            name="email"
            placeholder={t("email")}
            required
          />
          <Form.Control.Feedback type="invalid">
            {t("please_email")}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Control
            name="password"
            type="password"
            onChange={handleChange}
            aria-describedby="password"
            placeholder={t("password")}
            autoComplete="current-password"
            required
          />
          <Form.Control.Feedback type="invalid">
            {t("please_password")}
          </Form.Control.Feedback>
        </Form.Group>

        <div className="">
          <LoadingButton
            className="btn btn-primary btn-lg w-100 mb-3 btn-primaryF"
            type="submit"
            isLoading={isSubmitting}
          >
            {t("login")}
          </LoadingButton>
        </div>
      </Form>

      {/* Unified Status Modal */}
      <StatusModal ref={statusModalRef} statusCode={currentStatusCode} />
    </>
  );
}

export default LoginForm;
